import { Card } from "antd";
import React from "react";

const DeletedUsers = () => {
  return <Card>Deleted Users</Card>;
};

export default DeletedUsers;

